import css from 'styled-jsx/css'

export const styles: any = css`
  .benefits {
    padding-bottom: 7.5rem;
  }
`
